import { render, staticRenderFns } from "./InstructorDashboard.vue?vue&type=template&id=68bde4e8&scoped=true"
import script from "./InstructorDashboard.vue?vue&type=script&lang=js"
export * from "./InstructorDashboard.vue?vue&type=script&lang=js"
import style0 from "./InstructorDashboard.vue?vue&type=style&index=0&id=68bde4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bde4e8",
  null
  
)

export default component.exports